// This icon file is generated automatically.
var PShoppingOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12 3.88H9.87v-.25a2.88 2.88 0 00-5.74 0v.25H2a.5.5 0 00-.5.5v8.37c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V4.37a.5.5 0 00-.5-.5zm-6.75-.25a1.75 1.75 0 113.5 0v.25h-3.5v-.25zm6.13 8.5H2.62V5h1.5v1.38c0 .06.06.12.13.12h.88c.06 0 .12-.06.12-.13V5h3.5v1.38c0 .06.06.12.13.12h.87c.07 0 .13-.06.13-.13V5h1.5v7.13z", "fill-rule": "nonzero" } }] }, "name": "p-shopping", "theme": "outlined" };
export default PShoppingOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PShoppingOutlined.js
// module id = 3635
// module chunks = 0